import { findActiveBranchIndex } from "./schemaToRows";

function stripInjectedDiscriminators(data: any, schema: any): any {
  const anyOfTransformed = schema?.__anyOfTransformed as string[] | undefined;
  if (!Array.isArray(anyOfTransformed) || anyOfTransformed.length === 0)
    return data;
  if (!data || typeof data !== "object" || Array.isArray(data)) return data;

  const result: Record<string, unknown> = { ...data };
  for (const propKey of anyOfTransformed) {
    const obj = result[propKey];
    const discKey = `${propKey}_type`;
    if (obj && typeof obj === "object" && !Array.isArray(obj) && discKey in (obj as any)) {
      const { [discKey]: _strip, ...rest } = obj as Record<string, unknown>;
      result[propKey] = rest;
    }
  }
  return result;
}

function transformArraysToObjects(data: any, schema: any): any {
  if (!data || typeof data !== "object" || !schema || typeof schema !== "object") {
    return data;
  }

  if (Array.isArray(data)) {
    if (Array.isArray(schema?.items?.properties)) {
      return data.map((item) => transformArraysToObjects(item, schema.items));
    }
    if (schema?.items) {
      return data.map((item) => transformArraysToObjects(item, schema.items));
    }
    return data;
  }

  let result: Record<string, unknown> = { ...(data as Record<string, unknown>) };

  if (Array.isArray(schema.oneOf)) {
    const activeIndex = findActiveBranchIndex(schema, result);
    const activeBranch = activeIndex >= 0 ? schema.oneOf[activeIndex] : undefined;
    if (activeBranch) {
      result = transformArraysToObjects(result, activeBranch);
    }
  }

  if (schema.properties && typeof schema.properties === "object") {
    for (const key of Object.keys(schema.properties)) {
      const propSchema = schema.properties[key];
      const value = result[key];
      if (propSchema?.__fromAdditionalProperties && Array.isArray(value)) {
        const objectData: Record<string, any> = {};
        for (const item of value) {
          if (item && typeof item === "object" && "__key" in (item as any)) {
            const { __key, ...rest } = item as Record<string, any>;
            if (typeof __key === "string" && __key.trim()) {
              objectData[__key] = rest;
            }
          }
        }
        result[key] = objectData;
      } else if (value && typeof value === "object") {
        result[key] = transformArraysToObjects(value, propSchema);
      }
    }
  }

  return result;
}

export function rowsToData(draft: any, processedSchema: any): any {
  let next = draft ?? {};
  next = stripInjectedDiscriminators(next, processedSchema);
  next = transformArraysToObjects(next, processedSchema);
  return next;
}
